import React from 'react';

/**
 * UnifiedBadge — pill / chip for status, counters, and tags.
 *
 * Variants:
 *  - neutral | gold | success | warning | danger | info
 * Sizes: xs | sm | md
 */
export const UnifiedBadge = ({
  variant = 'neutral',
  size = 'sm',
  children,
  leftIcon,
  className = '',
  testId,
  style,
}) => {
  const variants = {
    neutral: {
      background: 'var(--mesp-bg-sunken)',
      color: 'var(--mesp-text-muted)',
      border: '1px solid var(--mesp-border)',
    },
    gold: {
      background: 'var(--mesp-gold-soft)',
      color: 'var(--mesp-gold)',
      border: '1px solid var(--mesp-gold-border)',
    },
    success: {
      background: 'var(--mesp-success-soft)',
      color: 'var(--mesp-success)',
      border: '1px solid var(--mesp-success-border)',
    },
    warning: {
      background: 'var(--mesp-warning-soft)',
      color: 'var(--mesp-warning)',
      border: '1px solid var(--mesp-warning-border)',
    },
    danger: {
      background: 'var(--mesp-danger-soft)',
      color: 'var(--mesp-danger)',
      border: '1px solid var(--mesp-danger-border)',
    },
    info: {
      background: 'var(--mesp-info-soft)',
      color: 'var(--mesp-info)',
      border: '1px solid var(--mesp-info-border)',
    },
  };

  const sizes = {
    xs: { padding: '1px 6px',  fontSize: '11px' },
    sm: { padding: '2px 8px',  fontSize: 'var(--mesp-font-xs)' },
    md: { padding: '4px 10px', fontSize: 'var(--mesp-font-sm)' },
  };

  return (
    <span
      data-testid={testId}
      className={`mesp-ui ${className}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        borderRadius: 'var(--mesp-radius-pill)',
        fontWeight: 'var(--mesp-font-weight-medium)',
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
        ...variants[variant],
        ...sizes[size],
        ...style,
      }}
    >
      {leftIcon}
      {children}
    </span>
  );
};

export default UnifiedBadge;
